import React, { useEffect, useState } from "react";
import EstimatingGrid from "@/pages/tabs/EstimatingGrid";
import BidSetup from "@/pages/tabs/BidSetup";

const SUBS = [
  { key: "grid", label: "Estimate grid" },
  { key: "setup", label: "Lead & details" },
];

// Estimating department: the grid is the hub; everything else folds into Bid setup.
export default function EstimatingTab({ bid, setBid, computed, taskTypes, crews, updateBid, perms, locked, load, pendingMeasure, setPendingMeasure }) {
  const [sub, setSub] = useState("grid");
  const ro = locked || !perms.canPrice;

  useEffect(() => { if (pendingMeasure) setSub("grid"); }, [pendingMeasure]);

  return (
    <div className="h-full flex flex-col">
      <div className="flex items-center gap-1 px-5 border-b border-slate-100 bg-white shrink-0">
        {SUBS.map((s) => (
          <button key={s.key} data-testid={`estimating-sub-${s.key}`} onClick={() => setSub(s.key)}
            className={`px-3 py-2 text-xs border-b-2 transition ${sub === s.key ? "border-[#F4C400] text-black font-medium" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
            {s.label}
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-auto min-h-0">
        {sub === "grid" && <EstimatingGrid bid={bid} computed={computed} taskTypes={taskTypes} updateBid={updateBid} readOnly={ro} pendingMeasure={pendingMeasure} clearPending={() => setPendingMeasure(null)} reload={load} />}
        {sub === "setup" && <BidSetup bid={bid} updateBid={updateBid} perms={perms} reload={load} />}
      </div>
    </div>
  );
}
